import { useTranslation } from 'react-i18next'

const INGREDIENT_KEYS = ['ham', 'milk', 'flour'] as const

/** Same croquetas demo numbers as the food-cost HowItWorks card (incl. VAT + fixed costs). */
export function EscandalloDemoCard() {
    const { t } = useTranslation()

    return (
        <div className='flex flex-col rounded-2xl border border-[#E2D9CB] bg-white px-[18px] py-5'>
            <div className='flex items-baseline justify-between pb-3'>
                <div className='text-[17px] font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.dishName')}</div>
                <div className='text-xs font-medium text-[#8A7F6F]'>{t('foodCost.howItWorks.demo.servings')}</div>
            </div>
            {INGREDIENT_KEYS.map(ingredientKey => (
                <div key={ingredientKey} className='flex items-baseline justify-between border-t border-[#E2D9CB] py-2'>
                    <div className='text-sm text-[#5C5548]'>
                        {t(`foodCost.howItWorks.demo.ingredients.${ingredientKey}`)}
                    </div>
                    <div className='text-sm font-semibold text-[#17130E]'>
                        {t(`foodCost.howItWorks.demo.prices.${ingredientKey}`)}
                    </div>
                </div>
            ))}
            <div className='flex items-center justify-between border-t border-[#E2D9CB] py-2'>
                <div className='flex items-center gap-2 text-sm text-[#8A7F6F]'>
                    {t('foodCost.howItWorks.demo.ingredients.butter')}
                    <span className='inline-flex gap-[3px]'>
                        <span className='h-1 w-1 rounded-full bg-[#F4502A]' />
                        <span className='h-1 w-1 rounded-full bg-[#F4502A]/55' />
                        <span className='h-1 w-1 rounded-full bg-[#F4502A]/25' />
                    </span>
                </div>
            </div>
            <div className='mt-1.5 flex flex-col border-t-2 border-[#17130E] pt-3.5'>
                <div className='flex items-baseline justify-between py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.currentPvp')}</div>
                    <div className='text-base font-bold text-[#17130E]'>
                        {t('foodCost.howItWorks.demo.prices.currentPvp')}
                    </div>
                </div>
                <div className='flex items-baseline justify-between border-t border-[#E2D9CB] py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.vat')}</div>
                    <div className='text-base font-bold text-[#8A7F6F]'>{t('foodCost.howItWorks.demo.prices.vat')}</div>
                </div>
                <div className='flex items-baseline justify-between border-t border-[#E2D9CB] py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>
                        {t('foodCost.howItWorks.demo.ingredientCost')}
                    </div>
                    <div className='flex items-baseline gap-2.5'>
                        <div className='text-base font-extrabold text-[#F4502A]'>
                            {t('foodCost.howItWorks.demo.prices.ingredientCost')}
                        </div>
                        <div className='text-[13px] font-semibold text-[#8A7F6F]'>
                            {t('foodCost.howItWorks.demo.prices.ingredientCostPct')}
                        </div>
                    </div>
                </div>
                <div className='flex items-baseline justify-between border-t border-[#E2D9CB] py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.fixedCosts')}</div>
                    <div className='flex items-baseline gap-2.5'>
                        <div className='text-base font-bold text-[#8A7F6F]'>
                            {t('foodCost.howItWorks.demo.prices.fixedCosts')}
                        </div>
                        <div className='text-[13px] font-semibold text-[#8A7F6F]'>
                            {t('foodCost.howItWorks.demo.prices.fixedCostsPct')}
                        </div>
                    </div>
                </div>
                <div className='mt-1 flex items-baseline justify-between border-t-2 border-[#17130E] pt-3'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.realProfit')}</div>
                    <div className='flex items-baseline gap-2.5'>
                        <div className='text-lg font-extrabold text-[#1FA855]'>
                            {t('foodCost.howItWorks.demo.prices.realProfit')}
                        </div>
                        <div className='text-[13px] font-semibold text-[#1FA855]'>
                            {t('foodCost.howItWorks.demo.prices.realProfitPct')}
                        </div>
                    </div>
                </div>
                <div className='flex items-baseline justify-between border-t border-[#E2D9CB] py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.idealPvp')}</div>
                    <div className='text-base font-bold text-[#17130E]'>
                        {t('foodCost.howItWorks.demo.prices.idealPvp')}
                    </div>
                </div>
                <div className='flex items-baseline justify-between border-t border-[#E2D9CB] py-1.5'>
                    <div className='text-sm font-bold text-[#17130E]'>{t('foodCost.howItWorks.demo.extraProfit')}</div>
                    <div className='flex items-baseline gap-2.5'>
                        <div className='text-base font-extrabold text-[#1FA855]'>
                            {t('foodCost.howItWorks.demo.prices.extraProfit')}
                        </div>
                        <div className='text-[13px] font-semibold text-[#1FA855]'>
                            {t('foodCost.howItWorks.demo.perServing')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
